// extracted by mini-css-extract-plugin
export default {"footerContainer":"Footer_footerContainer__7jnKn","lineWrapper":"Footer_lineWrapper__nu5IM","footerDetailWrapper":"Footer_footerDetailWrapper__uN4ht"};